export default __webpack_public_path__ + "f7a80fce985f7a04a0036eb1a5e675c3.png";